export const MESSAGE_LOAD_ERROR_TEXT =
  "Sorry, we're having issues and couldn't load this message.\n We apologize for the inconvenience";
